import React from 'react'
import PropTypes from 'prop-types'
import { useTheme } from '@emotion/react'
import { Autocomplete, TextField } from '../../mui/Core/index'

function GenericAutocomplete({
  width,
  label,
  dropdownOptions,
  handleSelectOption,
  selectedOption,
  rootStyle = {},
}) {
  const theme = useTheme()
  const handleOnChangeOption = (_event, selectedValue) => {
    if (handleSelectOption) {
      handleSelectOption(selectedValue)
    }
  }

  const handleGetLabelOption = (option) => {
    return option.description
  }

  const handleOnKeyDown = (event) => {
    const value = event.target.value
    if (event.key === 'Enter') {
      const option = dropdownOptions.filter((opt) => opt.description === value)[0]
      if (handleSelectOption && option) {
        handleSelectOption(option)
      }
    }
  }

  const renderInput = (params) => {
    const textFieldStyle = { fontSize: '16px', fontFamily: 'AtlasGroteskRegular' }
    return (
      <TextField
        // eslint-disable-next-line react/jsx-props-no-spreading
        {...params}
        sx={textFieldStyle}
        label={label}
      />
    )
  }

  const renderOption = (props, option) => {
    const optionLabelStyle = {
      fontSize: '16px',
      fontFamily: 'AtlasGroteskRegular',
      height: '48px',
    }
    return (
      <li
        // eslint-disable-next-line react/jsx-props-no-spreading
        {...props}
        key={option.id}
        style={optionLabelStyle}
      >
        {option.description}
      </li>
    )
  }

  const autoCompleteStyle = {
    width,
    borderColor: theme.palette.grey[700],
    borderRadius: '4px',
    ...rootStyle,
    '&.MuiAutocomplete-hasPopupIcon .MuiAutocomplete-inputRoot': {
      padding: '10px !important',
      fontSize: '16px',
      fontFamily: 'AtlasGroteskRegular',
    },
  }

  return (
    <Autocomplete
      sx={autoCompleteStyle}
      disableClearable
      value={selectedOption}
      onChange={handleOnChangeOption}
      options={dropdownOptions}
      getOptionLabel={handleGetLabelOption}
      renderInput={renderInput}
      renderOption={renderOption}
      onKeyDown={handleOnKeyDown}
    />
  )
}

GenericAutocomplete.propTypes = {
  height: PropTypes.string,
  width: PropTypes.string,
  label: PropTypes.string,
  rootStyle: PropTypes.objectOf(Object),
  handleSelectOption: PropTypes.func.isRequired,
  dropdownOptions: PropTypes.arrayOf(Object).isRequired,
  selectedOption: PropTypes.objectOf(Object),
}

export default GenericAutocomplete
